export enum Auth0Role {
  NONE = '',
  ADMIN = 'Admin',
  BBE_USER = 'BBE User',
  SUPER_ADMIN = 'Super Admin',
  CHANNEL_PARTNER = 'Channel Partner',
  CLIENT = 'Client',
}
